import React, { FC } from "react";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";

import { BusinessDivisionNewForm } from "./components/BusinessDivisionNewForm";

export const ManagersBusinessDivisionsNew: FC = () => {
  const breadCrumbItems = [
    { label: "部署設定", href: "/managers/business_divisions" },
    { label: "新規作成", href: "/managers/business_divisions/new" },
  ];

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent withRightSidebar>
        <BusinessDivisionNewForm />
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar />
    </EmployeeLayout>
  );
};
